import { Accountant, accountantReducer } from "./accountantReducers";
import {
  CSVInformationUIReducer,
  ICSVInformationUI,
} from "./CSVInformationUIReducer";
import {
  IAccountantListColumnsResponse,
  IAccountantListPayload,
} from "../../models/accountant";
import { IActivityLog, activityLogReducer } from "./activityLogReducers";
import { IClient, clientReducer } from "./clientReducers";
import { IDashboardApisData, dashboardApisDataReducer } from "./dashboardApisDataReducers";
import { IDrawer, drawerReducer } from "./drawerReducer";
import { IHomePage, homePageReducer } from "./homePageReducers";
import { IInvoiceReport, invoiceReportReducer } from "./invoiceReportReducers";
import {
  IIsLoadAxiosCall,
  isLoadAxiosCallReducer,
} from "./isLoadAxiosCallReducers";
import { INavigation, navigationReducer } from "./navigationReducers";
import {
  IResourceApiMessage,
  resourceApiMessageReducer,
} from "./resourceAPIMessageReducer";
import { IStickyNavBar, stickyNavBarReducer } from "./stickyNavBarReducers";
import { ITaxYear, taxYearReducer } from "./taxYearReducers";

import { ComponentState } from "../../common/enums";
import { IClientListPayload } from "../../models/client";
import { IEmployeeListPayload } from "../../models/employee";
import { IUserProfile } from "../../models/IUserProfile";
import { IVendorListPayload } from "../../models/vendor";
import { combineReducers } from "redux";
import loginReducer from "./loginReducers";
import { viewStateReducer } from "./viewStateReducer";

export interface IAppState {
  user: {
    profile: IUserProfile;
    isAuthenticated: boolean;
    token: string;
  };
  viewState: {
    loading: boolean;
    error: boolean;
    success: boolean;
    message: string;
    componentState: ComponentState;
  };
  accountant: Accountant;
  client: IClient;
  navigation: INavigation;
  taxYear: ITaxYear;
  invoice: IInvoiceReport;
  CSVInformationUI: ICSVInformationUI;
  HomePagePath: IHomePage;
  drawerAction: IDrawer;
  activityLog: IActivityLog;
  isLoadAxiosCall: IIsLoadAxiosCall;
  resourceApiMessage: IResourceApiMessage;
  stickyNavBar: IStickyNavBar;
  dashboardApisData: IDashboardApisData;
  }

const rootReducer = combineReducers({
  user: loginReducer,
  viewState: viewStateReducer,
  accountant: accountantReducer,
  client: clientReducer,
  navigation: navigationReducer,
  taxYear: taxYearReducer,
  invoice: invoiceReportReducer,
  CSVInformationUI: CSVInformationUIReducer,
  HomePagePath: homePageReducer,
  drawerAction: drawerReducer,
  activityLog: activityLogReducer,
  isLoadAxiosCall: isLoadAxiosCallReducer,
  resourceApiMessage: resourceApiMessageReducer,
  stickyNavBar: stickyNavBarReducer,
  dashboardApisData: dashboardApisDataReducer,
  });
export type RootState = IAppState;
export default rootReducer;
